<button
  type="{{ type() }}"
  class="{{ finalShape() + ' ' + display() }}"
  [disabled]="disabled()"
  (click)="clickedButton.emit($event)"
>
  @if (icon() && !asset()) {
    <art-icon [fontSize]="'24px'" shape="outlined">{{ icon() }}</art-icon>
  }
  @if (!icon() && asset()) {
    <div class="asset" [ngStyle]="{ 'background-image': 'url(assets/icon/' + asset() + '.svg)' }"></div>
  }
  @if (label()) {
    <dx-text type="ps" class="label" [ngStyle]="disabled() ? { color: 'var(--disabled)' } : {}">{{ label() }}</dx-text>
  }
</button>
